/**
 * File types the CRM accepts as card/ticket attachments; mirrors
 * `CrmLeadAttachmentRules` in the backend, which is the real check.
 */
export const CRM_ATTACHMENT_ACCEPT =
  ".jpg,.jpeg,.png,.gif,.webp,.mp4,.mov,.webm,.pdf,.doc,.docx,.txt,.csv,.xls,.xlsx";

/** Largest file the backend takes (videos). */
export const CRM_ATTACHMENT_MAX_BYTES = 50 * 1024 * 1024;

const OTHER_MAX_BYTES = 10 * 1024 * 1024;
const VIDEO_EXTENSIONS = [".mp4", ".mov", ".webm"];

const isVideo = (file: File) =>
  file.type.startsWith("video/") ||
  VIDEO_EXTENSIONS.some(extension =>
    file.name.toLowerCase().endsWith(extension)
  );

/** Size limit for this file: 50 MB for videos, 10 MB for anything else. */
export const crmAttachmentMaxBytes = (file: File): number =>
  isVideo(file) ? CRM_ATTACHMENT_MAX_BYTES : OTHER_MAX_BYTES;

/** User-facing reason the backend would reject the file, or null. */
export const crmAttachmentSizeError = (file: File): string | null =>
  file.size <= crmAttachmentMaxBytes(file)
    ? null
    : `"${file.name}" passa do limite de ${isVideo(file) ? "50 MB para vídeo" : "10 MB"}.`;

/** File size in pt-BR (`1,4 MB`), same wording as the DS `FileUpload`. */
export const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) return `${bytes} B`;

  const kb = bytes / 1024;
  if (kb < 1024)
    return `${kb.toLocaleString("pt-BR", { maximumFractionDigits: 0 })} KB`;

  return `${(kb / 1024).toLocaleString("pt-BR", { maximumFractionDigits: 1 })} MB`;
};
